import { devices } from 'rootstrap/global-styles/devices';
import styled, { css } from 'styled-components';

export const StyledRootSchemaComponent = styled.div<{
  isActive: boolean;
  isFirstElement: boolean;
  disableActiveElement: boolean | undefined;
  hiddenComponent?: boolean;
  className: 'schema-component';
  isMobile: boolean;
}>`
  padding-top: ${({ isActive, isFirstElement, disableActiveElement, isMobile }) =>
    isMobile ? '35px' : isActive && !isFirstElement ? '77px' : '35px'};

  ${({ disableActiveElement }) =>
    disableActiveElement &&
    css`
      padding-top: 25px;
    `}

  ${({ hiddenComponent }) =>
    hiddenComponent &&
    css`
      display: none;
    `}

  .field-divider {
    margin-top: ${({ isActive, isMobile }) => (isMobile ? '40px' : isActive ? '82px' : '40px')};
  }

  transition: padding-top 200ms ease-out, margin-top 200ms ease-out;
`;

export const StyledSliderRootSchemaComponent = styled(StyledRootSchemaComponent)`
  @media${devices.mobileL} {
    .form-group {
      padding-left: 14px !important;
      padding-right: 14px !important;
    }

    label {
      margin-left: -14px;
    }
  }
`;
